import { RouterView } from "vue-router";
import { ContractArchiveArchiveRouting } from "./archive/archive.routing";
export const ContractArchiveRouting = {
  path: "/contract-archive",
  redirect: "/contract-archive/archive",
  name: "contract-archive",
  component: RouterView,
  meta: { title: "合同归档" },
  children: [...ContractArchiveArchiveRouting],
};
